module.exports = __webpack_public_path__ + "static/media/close.123b7d37.svg";